import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { useTrans } from "../../../../hooks";
import { FormValidation } from "../FormValidation";
import { requiredField } from "../helpers";
import { MAP_MATURITY_RATINGS } from "../constants";
import ContestFormField from "../ContestFormField";
import ErrorField from "./ErrorField";

const StoryMaturityField = ({ form, onFormChange, fieldStatus, submitted }) => {
  const { trans } = useTrans();

  const title = trans("Story rating");

  const subtitle = (
    <div className="subtitle">
      {/* prettier-ignore */ trans("You are submitting your story with the rating listed below. To change the maturity your story is written in, please make any necessary edits in your story settings.")}
    </div>
  );

  const errorCondition =
    (fieldStatus.fieldInvalid ||
      (fieldStatus.fieldName !== "storyMaturity" &&
        fieldStatus.fieldName !== "" &&
        submitted)) &&
    form.storyMaturity === "";

  return (
    <ContestFormField title={title} subtitle={subtitle}>
      <FormValidation validationRules={[requiredField(trans)]}>
        {({ ref, errorMessage, className }) => (
          <React.Fragment>
            <select
              ref={ref}
              id="story-maturity-select"
              value={form.storyMaturity}
              name="storyMaturity"
              disabled
              className={classNames("form-element story-maturity", className)}
              onChange={onFormChange}
              aria-label={
                MAP_MATURITY_RATINGS(trans).find(
                  rating => rating.key === form.storyMaturity
                )?.value
              }
            >
              <option value="" disabled>
                {trans("Select a maturity level")}
              </option>
              {MAP_MATURITY_RATINGS(trans).map(rating => (
                <option key={rating.key} value={rating.key}>
                  {rating.value}
                </option>
              ))}
            </select>
            <ErrorField
              errorMessage={errorMessage}
              errorCondition={errorCondition}
              fieldId={"story-maturity"}
            />
          </React.Fragment>
        )}
      </FormValidation>
    </ContestFormField>
  );
};

StoryMaturityField.propTypes = {
  form: PropTypes.object.isRequired,
  onFormChange: PropTypes.func.isRequired,
  fieldStatus: PropTypes.shape({
    fieldInvalid: PropTypes.bool,
    fieldName: PropTypes.string
  }).isRequired,
  submitted: PropTypes.bool.isRequired
};

export default StoryMaturityField;
